export default __webpack_public_path__ + "static/media/thermometer.d98a03ef.png";